import { z } from "zod";
const BetSchema = z.object({
  bet_home_name: z.string(),
  market_event: z.string(),
  info_market_event: z.string(),
  commission: z.number(),
  backStake: z.number(),
  chance: z.number(),
  stake: z.number(),
  block_chance: z.boolean(),
  block_stake: z.boolean(),
  profit: z.number()
});
const MarketDetailsSchema = z.object({
  title: z.string(),
  sub_title: z.string(),
  part_link: z.string(),
  // server sends ISO; we accept string and convert to Date later
  time_expiration: z.string().refine((s) => !Number.isNaN(Date.parse(s)), { message: "Invalid datetime" }),
  type_surebet: z.string(),
  round_is_selected: z.boolean(),
  round_value: z.number(),
  index_bookmaker_selected: z.number(),
  bonus_value: z.number(),
  bonus_proportion_value: z.number()
});
const OperationSchema = z.object({
  marketDetails: MarketDetailsSchema,
  marketOperations: z.array(BetSchema)
});
export {
  BetSchema,
  MarketDetailsSchema,
  OperationSchema
};